/* eslint-disable jira/filename-case */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from './createJpdExperience.tsx';
import type { JPDExperience } from './ExperienceMetadataExtra.types.tsx';

export const copy: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.copy-project-configuration', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
